<template>
    <div class="flex h-screen bg-gray-50">
      <MainSidebar />
      <div class="flex-1 p-6 overflow-auto">
        <router-view /> <!-- ✅ ตรงนี้คือเนื้อหาของแต่ละหน้า -->
      </div>
    </div>
  </template>
  
  <script>
  import MainSidebar from '../components/Sidebar.vue'
  
  export default {
    name: 'MainLayout',
    components: {
      MainSidebar
    }
  }
  </script>
  